/** Reads an optional dotted projection without trusting JSON object shapes. */
export function readExportValue(row: unknown, key: string): unknown {
  return key.split(".").reduce<unknown>((value, part) =>
    value !== null && typeof value === "object"
      ? (value as Record<string, unknown>)[part]
      : undefined, row);
}
